import React from "react";
import Button from "@material-ui/core/Button";
import DialogUI from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import { GlobalDialogProps } from "../../utils/types/components";

/**
 * Dialog
 */

export const Dialog = ({
  open,
  onClose,
  title,
  content,
  handleAccept,
  handleCancel,
  type = "info",
}: GlobalDialogProps): React.ReactElement => (
  <DialogUI
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description">
    {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
    <DialogContent>
      {typeof content === "string" ? (
        <DialogContentText id="alert-dialog-description">
          {content}
        </DialogContentText>
      ) : (
        content
      )}
    </DialogContent>
    <DialogActions>
      {handleCancel && (
        <Button onClick={handleCancel} color="primary">
          Cancelar
        </Button>
      )}
      {handleAccept && (
        <Button onClick={handleAccept} color="primary" autoFocus>
          Aceptar
        </Button>
      )}
    </DialogActions>
  </DialogUI>
);
